import {Component, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {RxAuthService} from 'src/app/services/rx-auth/rx-auth.service';
import {HttpClient} from '@angular/common/http';
import {ChartsCommonFunctions} from '../chartsCommonFunctions';
import {environment} from 'src/environments/environment';
import {ListProfileComponent} from 'src/app/profiles/list-profile/list-profile.component';
import {RetailerProfileComponent} from 'src/app/profiles/retailer-profile/retailer-profile.component';
import {ActivatedRoute} from '@angular/router';
import * as Plotly from 'plotly.js-dist-min'
import {ElementRef} from '@angular/core';
import {LoaderComponent} from '../../loader/loader.component';
import {NgIf} from '@angular/common';
import {ChartHeaderComponent} from '../chart-header/chart-header.component';
import {ChartWrapperComponent} from '../chart-wrapper/chart-wrapper.component';
import {Subscription} from "rxjs";
import {SettingsService} from "../../../../services/settings/settings.service";

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  standalone: true,
  imports: [
    LoaderComponent,
    NgIf,
    ChartHeaderComponent
  ]
})
export class BarChartComponent {
  @Input() rcl: any = '';
  @Input() model: any = '';
  @Input() chartId: string = '';
  @Input() retailer: any = null;
  @Input() isEditMode: boolean = false;

  @ViewChild('chartContainer', {static: true}) chartContainer!: ElementRef;
  showchart: boolean = false;
  profile: any = {}
  current_list = ''

  hasThumbnail: boolean = false;
  plotlyChart: any = null
  originalChart: any = null
  text_elements: any = ''
  plotId: string = '';


  constructor(private auth: RxAuthService,
              private http: HttpClient,
              private common: ChartsCommonFunctions,
              private listprofile: ListProfileComponent,
              private retailerprofile: RetailerProfileComponent,
              private route: ActivatedRoute,
              public elementRef: ElementRef,
              public renderer: Renderer2,
              public chartWrapper: ChartWrapperComponent,
  ) {
  }


  chartData: any = {
    data: [
      {
        y: ['fashion', 'things', 2012, 2013, 2014], // x-axis data for first trace
        x: [1, 3, 2, 4, 5], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#3792BF'}
      },
    ],
    layout: {
      legend: {orientation: 'h', y: 1.2},
      xaxis: {
        visible: false
        //title: 'X-axis', // x-axis label
      },
      yaxis: {
        type: 'category'
        //title: 'Y-axis' // y-axis label
      },

      margin: {r: 30, l: 150, t: 10, b: 20},
      height: 300,
      autosize: true,
    },
    config: {
      displayModeBar: false,
      staticPlot: this.common.isMobile()
    },
  };

  ngOnInit() {
    this.plotId = `#plot${this.chartId}`
    this.common.isIframe(this.elementRef, this.renderer)
    let currentPath = this.route.snapshot.url[0].path
    if (currentPath === 'shared' || currentPath === 'saved-charts') {
      let url = `${environment.backend_base}main/visualizations/get_public_chart_metadata/`;
      let payload = {rcl: this.rcl};

      this.http.post(url, payload).subscribe((response: any) => {
        this.profile = response.profile;
        this.current_list = response.profile.current_list;
        this.getData(this.rcl);
      });
    } else if (!this.retailer) {
      this.profile = this.listprofile;
      this.current_list = this.profile.listProfile.current_list;
      this.getData(this.rcl);
    } else if (currentPath !== 'shared' && currentPath !== 'saved-charts') {
      this.profile = this.retailerprofile;
      this.current_list = this.profile.retailerProfile.current_list;
      this.getData(this.rcl);
    }
  }

  getData(rcl: number | null) {
    let url = `${environment.backend_base}main/visualizations/get_visualization_data/`;
    let payload = {
      visualization: this.model,
      rcl: rcl,
      component: this.route.component!.name
    };

    let options = this.auth.httpOptions;

    this.http
      .post(url, payload, this.auth.httpOptions)
      .subscribe((response: any) => {
          this.chartData.data[0].x = response.data[0].fields.json[0].x
          this.chartData.data[0].y = response.data[0].fields.json[0].y
          this.chartData.data[0].text = response.data[0].fields.json[0].text
          //this.chartData.data[0].orientation = response.data[0].fields.json[0].orientation
          this.chartData.layout.margin.l = this.common.barChartDynamicLeftMargin(this.chartData)
          if (this.chartData.data[0].orientation === 'v') {
            this.chartData.layout.margin.b = 200
          }

          this.chartData.data[0].hovertemplate = '%{y}, %{text}<extra></extra>'

          this.text_elements = this.common.getTextElements(response.text_elements, this.profile)

          this.plotlyChart = this.chartContainer.nativeElement.querySelector(this.plotId)
          this.plotlyChart = Plotly.newPlot(this.plotlyChart, this.chartData.data, this.chartData.layout, this.chartData.config)

          this.common.subscribeToUserEvents(this.plotlyChart, this.chartWrapper)
          this.originalChart = this.common.removeCircularReferences(this.plotlyChart);
          this.showchart = true

        }
      )
  }

  resizeChart(width: number, height: number, plotId: any) {
    this.chartId = plotId;
    this.plotId = `#plot${this.chartId}`
    this.plotlyChart = this.elementRef.nativeElement.querySelector(this.plotId)

    Plotly.relayout(this.plotlyChart, {'width': width, 'height': height})

  }

  checkIfThumbnail() {
    return this.hasThumbnail
  }
}
